import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Logo from "../img/my_logo_tm.png";
import { Link, NavLink , useLocation } from "react-router-dom";
import { BiMenuAltRight } from "react-icons/bi";
import { FaTimes, FaChevronDown } from "react-icons/fa";
import Four_Square from "../school_images/dropdown_logo.png";

// Styled Components
const NavigationContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
`;

const NavContent = styled.div`
  display: flex;
  justify-content: space-between !important;
  align-items: center;
  padding: 0 0.1rem;
  height: 100px;
  width: 100%;
  margin: 0;
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;

const CenterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;

  @media (max-width: 968px) {
    display: none;
  }
`;

const RightContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 968px) {
    display: none;
  }
`;

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  
  img {
    height: 100px;
    width: auto;
  }
`;

const MenuIcon = styled.div`
  display: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #333;
  
  @media (max-width: 968px) {
    display: block;
  }
`;

const MenuList = styled.ul`
  display: flex;
  align-items: start;
  list-style: none;
  margin: 0;
  padding: 0;
  
  @media (max-width: 968px) {
    position: fixed;
    top: 100px;
    left: 0;
    width: 100%;
    height: ${props => props.isOpen ? 'calc(100vh - 100px)' : '0'};
    overflow-y: auto;
    background-color: #fff;
    flex-direction: column;
    align-items: flex-start;
    transition: height 0.3s ease;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  }
`;

const MenuItem = styled.li`
  position: relative;
  margin: 0 0.5rem;
  
  @media (max-width: 968px) {
    width: 100%;
    margin: 0;
    border-bottom: 1px solid #f0f0f0;
  }
`;

const NavLinkStyled = styled(NavLink)`
  display: flex;
  align-items: center;
  margin: 0.1rem 0.1rem;
  color: #333;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: color 0.3s;
  position: relative;
  
  &:hover {
    color: #2c975b;
  }
  
  &.active {
    color: #2c975b;
    

  }
  
  @media (max-width: 968px) {
    padding: 1rem 1.5rem;
    width: 100%;
    
    &.active::after {
      left: 1.5rem;
      right: 1.5rem;
    }
  }
`;

const DropdownIcon = styled(FaChevronDown)`
  margin-left: 0.3rem;
  font-size: 0.7rem;
  transition: transform 0.3s;
  
  ${props => props.$isOpen && `
    transform: rotate(180deg);
  `}
`;

const DropdownContent = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  min-width: 280px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 0.5rem 0;
  z-index: 100;
  display: ${props => props.$isOpen ? 'block' : 'none'};
  
  @media (max-width: 968px) {
    position: static;
    box-shadow: none;
    min-width: 100%;
    display: ${props => props.$isOpen ? 'block' : 'none'};
    padding-left: 1.5rem;
  }
`;

const DropdownItem = styled(Link)`
  display: block;
  padding: 0.7rem 1.5rem;
  color: #555;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s;
  display: flex;
  align-items: flex-start;
  font-weight: 600;
  
  
  &:hover {
    color: #2c975b;
    background-color: #f9f9f9;
  }
  
  @media (max-width: 968px) {
    padding: 0.8rem 1.5rem;
  }
`;





const MenulistTesting = [
  {
    title: "Home",
    url: "/"
  },
  {
    title: "About Us",
    url: "/about-srk",
    dropdownItems: [
      { title: "About-SRK", url: "/about-srk" },
      { title: "Company Profile", url: "https://drive.google.com/uc?export=download&id=1nmzIG9VBuD5X5-P3oATkaPIlfaR0Mouf" },
    ]
  },
  {
    title: "Doctor Special",
    url: "/online-appointment-system",
    dropdownItems: [
      { title: "Online Appointment System", url: "/online-appointment-system" },
      { title: "Dynamin Website", url: "/dynamic-web-apps" },
      { title: "Campaigning & Lead generation ", url: "/lead-generation" },
      { title: "Social Media Management", url: "/online-reputation-management" },
      { title: "Digital Marketing", url: "/digital-marketng-for-doctor" },
      { title: "SEO & Youtube ", url: "/seo-youtube-for-doctor" },
    ]
  },
  {
    title: "Web Design ",
    url: "/graphic-designing",
    dropdownItems: [
      { title: "Graphic Design", url: "/graphic-designing" },
      { title: "Logo & Branding", url: "/logo-designing" },
      { title: "Custom Web Design", url: "/custom-web-designing" },
      { title: "Wordpress Design", url: "/wordpress-design" },
      { title: "E-Commerce Design", url: "/custom-e-commerce-design" },
      { title: "Woo-Commerce", url: "/woo-commerce-design" },
    ]
  },
  {
    title: "Web / App Development",
    url: "/web-development", 
    dropdownItems: [
      { title: "Web Development", url: "/web-development" },
      { title: "Mobile App Development", url: "/mobile-app-development" },
      { title: "Software Development", url: "/software-development" },
      { title: "SAAS Development", url: "/saas-development" },
    ]
  },
  {
    title: "360 Digital Marketing",
    url: "/social-media-marketing", 
    dropdownItems: [
      { title: "Social Media Marketing", url: "/social-media-marketing" },
      { title: "PPC", url: "/ppc" },
      /* { title: "Content Marketing", url: "/content-marketing" }, */
      { title: "Email Marketing", url: "/email-marketing" },
      { title: "Linkedin Marketing", url: "/linkdin-marketing" },
      { title: "Analytics", url: "/analytics" },
      { title: "Social Media / Reputation Management", url: "/social-media-reputation-management" },
    ]
  },
  {
    title: "SEO Services",
    url: "/career", 
    dropdownItems: [
      { title: "SEO for Small Business", url: "/seo-for-small-business" },
      { title: "Local SEO (GMB)", url: "/local-seo-gmb" },
      { title: "Custom SEO Solution", url: "/custom-seo-solution" },
    /*   { title: "E-commerce SEO", url: "/e-commerce-seo" }, */
      { title: "SEO Audit", url: "/seo-audit" },
     /*  { title: "Analytics & Reporting", url: "/analytics-reporting" }, */
    ]
  },
  /* {
    title: "Career",
    url: "/careers"
  }, */
  {
    title: "Contact Us",
    url: "/contact"
  },
];

const Navbaartesting = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeParent, setActiveParent] = useState(null);
  const location = useLocation();
  const navRef = useRef(null);

  // Track scroll shadow
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Highlight parent menu when child route matches
  useEffect(() => {
    MenulistTesting.forEach((menu, idx) => {
      if (menu.dropdownItems) {
        const match = menu.dropdownItems.some(
          (item) => item.url === location.pathname
        );
        if (match) setActiveParent(idx);
      }
      if (menu.url === location.pathname) {
        setActiveParent(idx);
      }
    });
  }, [location.pathname]);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleDropdown = (index) =>
    setOpenDropdown(openDropdown === index ? null : index);
  const closeMenu = () => {
    setIsMenuOpen(false);
    setOpenDropdown(null);
  };

  const menuLists = MenulistTesting.map(({ url, title, dropdownItems }, index) => {
    const hasDropdown = dropdownItems && dropdownItems.length > 0;
    const isDropdownOpen = openDropdown === index;
    const isActive = activeParent === index;

    return (
      <MenuItem key={index}>
        {hasDropdown ? (
          <>
            <NavLinkStyled
              to={url}
              className={isActive ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                toggleDropdown(index);
              }}
            >
              {title}
              <DropdownIcon $isOpen={isDropdownOpen} />
            </NavLinkStyled>
            <DropdownContent $isOpen={isDropdownOpen}>
              {dropdownItems.map((item, idx) => (
                <DropdownItem
                  key={idx}
                  to={item.url}
                  onClick={closeMenu}
                >
                  {item.title}
                </DropdownItem>
              ))}
            </DropdownContent>
          </>
        ) : (
          <NavLinkStyled
            to={url}
            className={isActive ? "active" : ""}
            onClick={closeMenu}
          >
            {title}
          </NavLinkStyled>
        )}
      </MenuItem>
    );
  });

  return (
    <NavigationContainer
      ref={navRef}
      style={{
        boxShadow: isScrolled ? "0 2px 10px rgba(0, 0, 0, 0.1)" : "none",
      }}
    >
      <NavContent
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <LogoContainer to="/" onClick={closeMenu}>
          <img src={Logo} alt="logo" />
        </LogoContainer>

        <MenuList isOpen={isMenuOpen}>{menuLists}</MenuList>

        <MenuIcon onClick={toggleMenu}>
          {isMenuOpen ? <FaTimes /> : <BiMenuAltRight />}
        </MenuIcon>
      </NavContent>
    </NavigationContainer>
  );
};

export default Navbaartesting;